import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useFlyoutContext } from './Flyout.context';
export const FlyoutTrigger = (props) => {
    const { children } = props;
    const { id, triggerElRef, triggerType, flyout, handleFocus, handleBlur, handleMouseEnter, handleMouseLeave, handleClick, trapFocusMode, } = useFlyoutContext();
    let childrenAttributes;
    if (triggerType === 'hover') {
        childrenAttributes = {
            onBlur: handleBlur,
            ref: triggerElRef,
            onFocus: handleFocus,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            'aria-describedby': id,
        };
    }
    else {
        childrenAttributes = {
            onBlur: handleBlur,
            ref: triggerElRef,
            onClick: handleClick,
            'aria-haspopup': trapFocusMode === 'dialog' ? 'dialog' : 'menu',
            'aria-expanded': flyout.status !== 'idle',
            'aria-controls': flyout.status !== 'idle' ? id : undefined,
        };
    }
    return _jsx(_Fragment, { children: children(childrenAttributes) });
};
